import { Serializable } from '@admin/core/models/serializable';

export class IndexationReport implements Serializable<IndexationReport> {
  fromObject(obj: any): IndexationReport {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public jobseeker: IndexationReportItem;
  public announcement: IndexationReportItem;
  public customer: IndexationReportItem;
  public transaction: IndexationReportItem;
}

export class IndexationReportItem
  implements Serializable<IndexationReportItem>
{
  fromObject(obj: any): IndexationReportItem {
    Object.assign(this, obj);
    return this;
  }

  toObject() {
    throw new Error('Method not implemented.');
  }

  public partitions: number;
  public successIndexationCount: number;
  public failedIndexationCount: number;
  public todoIndexationCount: number;
}
